// @mui
import Container from '@mui/material/Container';
import { useSettingsContext } from 'src/components/settings';
import PagesMainNavMenu from './pages-main-nav-menu';

// ----------------------------------------------------------------------

export default function WebsitePages() {
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
          <PagesMainNavMenu/>
        </Container >
    );
}
